/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { ILanding, ILandingCategory } from "../data/interfaces";
import { ILandingStore, useLandingStore } from "../data/store";

export default function useCategory(name:string = ""): ILandingCategory | undefined {
    const landing = useLandingStore((state: ILandingStore) => state.currentLanding)
    const getCat = (currentLanding: ILanding )  => {
        const landingCategories: ILandingCategory[] = currentLanding.categories || []
        set_category( landingCategories.find(ct => ct.id ===  name) || {} as ILandingCategory )
    } 
    const [_category, set_category] = useState<ILandingCategory | undefined>() 

    useEffect(() => useLandingStore.subscribe(
        (state: ILandingStore) => getCat(state.currentLanding)
    ), [ name ])

    useEffect(() => {
        getCat( landing )
    }, [ name ])
    
    return _category
}